import store from '../../store'

export function hideDocTemplatesModal() {	
	store.dispatch({type:'HIDE_DOC_TEMPLATES_MODAL'})
}
